const joinReverseTariffOptionsExtra = function (extraData, allOptions = null) {
  const option = allOptions.find(item => {
    return (item.tariffoptionId === extraData.id)
  })
  return {
    ...extraData,
    option: option
  }
}

export default joinReverseTariffOptionsExtra
